import React, {useEffect, useState} from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { default as TooltipButton } from 'react-bootstrap/Button';
import { useFormContext } from 'react-hook-form';
import { DebounceInput } from 'react-debounce-input';

/* Common */
import { Icon } from '~/components/common';

/* Icons */
import InfoIcon from '~/../symbols/info-circle.svg';
import Form from "react-bootstrap/Form";

export default function ConversionFieldMoney(props) {
    const [error, setError] = useState(false)
    const { field, vehiclePrice, path, updateValue, id, loading } = props;
    const { type, required, disabled, placeholder = null, value, name } = field;

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    const handleChange = (e) => {
        const inputValue = e.target.value;

        if (!inputValue) return false;

        if (name === 'deposit') {
            if (parseInt(inputValue) > parseInt(vehiclePrice)) {
                setError(true);
            } else {
                setError(false);
                updateValue(inputValue, () => {
                    trigger(path);
                });
            }
        } else {
            updateValue(inputValue, () => {
                trigger(path);
            });
        }
    };

    return (
        <div className="row gutters-0 mb-5">
            <div className="col-12">
                <div className="d-flex align-items-center justify-content-between mb-1 mb-xl-2">
                    <label htmlFor={props.id} className="flow__label">
                        {field?.label}
                    </label>
                    {field?.config?.tooltip && (
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip id={`tooltip-${field.name}`}>
                                    {field.config.tooltip}
                                </Tooltip>
                            }
                        >
                            <TooltipButton
                                variant="none"
                                className="ml-1 p-0 mt-0"
                            >
                                <Icon
                                    theme="base"
                                    size={16}
                                    url={InfoIcon?.url}
                                    className={`icon--tooltip`}
                                />
                            </TooltipButton>
                        </OverlayTrigger>
                    )}
                </div>
                <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                    <DebounceInput
                        element={Form.Control}
                        debounceTimeout={500}
                        className={`${error ? ' is-error' : ''}${loading ? ' form-control--loading' : ''}`}
                        placeholder={placeholder}
                        name={id}
                        type="number"
                        required={required}
                        disabled={disabled || loading}
                        value={value || ''}
                        onChange={handleChange}
                    />
                    {error && (
                        <Form.Control.Feedback type="invalid">
                            {'Het ingevoerde bedrag is hoger dan de prijs van de auto, vul een lager bedrag in.'}
                        </Form.Control.Feedback>
                    )}
                </Form.Group>
            </div>
        </div>
    );
}
